//adminfrontend/src/admin_ui/services/adminInventoryApi.js
import adminApiClient from "./adminApiClient";

const adminInventoryApi = {
  async receiveManufactured(payload) {
    const res = await adminApiClient.post("/api/inventory/stock/receive-manufactured", payload);
    return res.data;
  },
  async listReceivableBatches(params) {
    const res = await adminApiClient.get("/api/inventory/receivable-batches", { params });
    return res.data;
  },
  async listBranches() {
    const res = await adminApiClient.get("/api/inventory/branches");
    return res.data;
  },

  async createBranch(payload) {
    const res = await adminApiClient.post("/api/inventory/branches", payload);
    return res.data;
  },

  async listLocations(branchId) {
    const res = await adminApiClient.get("/api/inventory/locations", {
      params: { branchId },
    });
    return res.data;
  },

  async createLocation(payload) {
    const res = await adminApiClient.post("/api/inventory/locations", payload);
    return res.data;
  },

  async listStockLevels(params) {
    const res = await adminApiClient.get("/api/inventory/stock-levels", { params });
    return res.data;
  },
  
  async listStockMovements(params) {
    const res = await adminApiClient.get("/api/inventory/stock-movements", { params });
    return res.data;
  },
};

export default adminInventoryApi;
